var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"section-banner header-space"},[_c('slick',{ref:"bannerslider",attrs:{"options":_vm.bannerSlider}},_vm._l((_vm.bannersBrij),function(data,index){return _c('div',{key:index,staticClass:"w-100 banner-slider"},[_c('div',{staticClass:"banner-img"},[_c('div',[_c('img',{staticClass:"banner-movie-img d-block d-md-none",attrs:{"src":_vm.checkBaseUrl(
                _vm.getLangSpecificAttribute(
                  data.languageSpecificImages,
                  _vm.getCurrentLang().brij_lang_id,
                  'mobile_banner_image_url',
                  'lang_id'
                ) ||
                  data.mobile_banner_image_url ||
                  data.banner_image_url
              ),"onerror":"javascript:this.src='/static/img/default-banner.jpg'"}}),_vm._v(" "),_c('img',{staticClass:"banner-movie-img d-none d-md-block",attrs:{"src":_vm.checkBaseUrl(
                _vm.getLangSpecificAttribute(
                  data.languageSpecificImages,
                  _vm.getCurrentLang().brij_lang_id,
                  'banner_image_url',
                  'lang_id'
                ) || data.banner_image_url
              ),"onerror":"javascript:this.src='/static/img/default-banner.jpg'"}})]),_vm._v(" "),_c('div',{staticClass:"banner-content",style:(data.banner_type_id != 2 && data.banner_generic_url
              ? 'width:30%'
              : '')},[_c('div',{staticClass:"content"},[_c('div',{},[(
                  (data.banner_type_id == 1 && data.movie_id) ||
                    (!data.banner_type_id != 2 && data.banner_generic_url)
                )?_c('button',{staticClass:"btn-cta-primary",on:{"click":function($event){return _vm.goToMovieDetails(data, '1')}}},[_vm._v("\n                "+_vm._s(_vm.langName == "ar" && data.buttonTextArray[1].button_text
                    ? data.buttonTextArray[1].button_text
                    : data.buttonTextArray[0].button_text
                    ? data.buttonTextArray[0].button_text
                    : _vm.allLanguageData.BookNow)+"\n              ")]):(data.banner_type_id == 4 && data.banner_os_id)?_c('button',{staticClass:"btn-cta-primary",on:{"click":function($event){return _vm.goToShowTimes(data, '4')}}},[_vm._v("\n                "+_vm._s(_vm.langName == "ar" && data.buttonTextArray[1].button_text
                    ? data.buttonTextArray[1].button_text
                    : data.buttonTextArray[0].button_text
                    ? data.buttonTextArray[0].button_text
                    : _vm.allLanguageData.BookNow)+"\n              ")]):_vm._e()])])])])])}),0)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ddfb893a","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/partials/bannerSlider.vue
// module id = 1094
// module chunks = 4